import { Select, SelectOption } from "@clockwise/design-system";
import React from "react";
import { createFragmentContainer } from "react-relay";
import { teamPickerFragments } from "./TeamPicker.gql";
import { IContainer, IProps, IState } from "./TeamPickerTypes";

//////////////////
// COMPONENT
//////////////////
class TeamPickerCmpt extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      selectedTeamId: props.teamId,
    };
  }

  // ~-~-~-~-~-~-~-
  // Lifecycle
  // ~-~-~-~-~-~-~-
  public UNSAFE_componentWillReceiveProps(nextProps: IProps) {
    if (nextProps.teamId !== this.state.selectedTeamId) {
      this.setState({ selectedTeamId: nextProps.teamId });
    }
  }

  // ~-~-~-~-~-~-~-
  // Helpers;
  // ~-~-~-~-~-~-~-
  private onChange = (selectedTeamId: string) => {
    this.props.onChange(selectedTeamId);
    this.setState({ selectedTeamId });
  };

  public render() {
    const { userTeams } = this.props;
    const { selectedTeamId } = this.state;

    const sortedList = [...userTeams.list].sort((a, b) => a.teamName.localeCompare(b.teamName));

    return (
      <div className="cw-flex-1 cw-w-full cw-mt-2">
        <Select
          value={selectedTeamId}
          onChange={this.onChange}
          label="Primary team"
          name="Team Picker"
          fullWidth
          size="large"
        >
          {sortedList.map((team) => (
            <SelectOption
              cw-id="team-in-teampicker"
              key={`team-select-${team.teamId}-${team.teamName}`}
              value={team.teamId}
            >
              {team.teamName}
            </SelectOption>
          ))}
        </Select>
      </div>
    );
  }
}

export const TeamPicker = createFragmentContainer<IContainer>(TeamPickerCmpt, teamPickerFragments);
